import script from "./SfFooter.vue?vue&type=script&setup=%7Bname%3A%20'SfFooter'%7D&lang=ts"
export * from "./SfFooter.vue?vue&type=script&setup=%7Bname%3A%20'SfFooter'%7D&lang=ts"

import "./SfFooter.vue?vue&type=style&index=0&id=73083f3f&scoped=true&lang=less"

import exportComponent from "/app/10119217139/workspace/IBU-IFSP_PUBLIC/IBU-IFSP-OPENAPI/OPENAPI_WEB_PORTAL_BUILD_GKE_DIRECT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73083f3f"]])

export default __exports__